import { render } from "./arrow_right.svg?vue&type=template&id=6703600a"
const script = {}
script.render = render

export default script